<app-entity-edit [entityEditBaseComponent]="this"
                        [isTitleEditable]="false"
                        [stereotyped]="false"
                        [useTitle]="creating"
                        displayKey="name">
</app-entity-edit>

<!-- Location Templates -->
<ng-template #locationSelectLabelTitleTemplate let-item="item">
  <app-master-data-locations-location-location-number [label]="true"
                                                             [location]="item">
  </app-master-data-locations-location-location-number>
</ng-template>

<ng-template #locationSelectOptionTitleTemplate let-item="item" let-searchTerm="searchTerm">
  <app-master-data-locations-location-location-number [label]="false"
                                                             [location]="item"
                                                             [searchTerm]="searchTerm">
  </app-master-data-locations-location-location-number>
</ng-template>
